import { render, staticRenderFns } from "./InlineProductBrowser.vue?vue&type=template&id=32a34acb&scoped=true"
import script from "./InlineProductBrowser.vue?vue&type=script&lang=js"
export * from "./InlineProductBrowser.vue?vue&type=script&lang=js"
import style0 from "./InlineProductBrowser.vue?vue&type=style&index=0&id=32a34acb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a34acb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32a34acb')) {
      api.createRecord('32a34acb', component.options)
    } else {
      api.reload('32a34acb', component.options)
    }
    module.hot.accept("./InlineProductBrowser.vue?vue&type=template&id=32a34acb&scoped=true", function () {
      api.rerender('32a34acb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/display-builder/InlineProductBrowser.vue"
export default component.exports